import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Contractors from "./pages/Contractors";
import Suppliers from "./pages/Suppliers";
import Bim from "./pages/Bim";
import Contracts from "./pages/Contracts";
import ContractDetail from "./pages/ContractDetail";
import Estimations from "./pages/Estimations";
import EstadoCuenta from "./pages/EstadoCuenta";
import Cobranza from "./pages/Cobranza";
import ProjectDocs from "./pages/ProjectDocs";
import ErpReports from "./pages/ErpReports";
import DeletedRecords from "./pages/DeletedRecords";
import Audits from "./pages/Audits";
import { PLANOS_CONFIG, NORMATIVA_CONFIG, LEGALES_CONFIG, CONTABLE_CONFIG } from "./lib/constants";
import FixedExpenses from "./pages/FixedExpenses";
import UsersPage from "./pages/UsersPage";
import EmailLog from "./pages/EmailLog";
import Bitacora from "./pages/Bitacora";
import Auditoria from "./pages/Auditoria";
import PortalCliente from "./pages/PortalCliente";
import ClientPortal from "./pages/ClientPortal";
import Concursos from "./pages/Concursos";
import Reportes from "./pages/Reportes";
import WhatsAppAlerts from "./pages/WhatsAppAlerts";
import Chat from "./pages/Chat";
import Tareas from "./pages/Tareas";
import Programa from "./pages/Programa";
import WorkOrders from "./pages/WorkOrders";
import Recorridos360 from "./pages/Recorridos360";
import CompanyDirectory from "./pages/CompanyDirectory";
import Access from "./pages/Access";
import WorkItems from "./pages/WorkItems";
import Photos from "./pages/Photos";
import Employees from "./pages/Employees";


function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null)
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (location.pathname.startsWith("/erp") && !["admin", "gerente_general"].includes(user.role)) return <Navigate to="/" replace />;
  if (user.role === "seguridad" && !(Array.isArray(user.allowed_sections) && user.allowed_sections.length) && location.pathname !== "/acceso") return <Navigate to="/acceso" replace />;
  const allowedSecs = user.allowed_sections;
  if (Array.isArray(allowedSecs) && allowedSecs.length && !allowedSecs.includes("all") && user.role !== "admin") {
    const p = location.pathname;
    const ok = allowedSecs.some((s) => s === p || (s !== "/" && p.startsWith(s)));
    if (!ok) return <Navigate to={allowedSecs[0]} replace />;
  }
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/obra/:token" element={<ClientPortal />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/contratistas" element={<Protected><Contractors /></Protected>} />
            <Route path="/proveedores" element={<Protected><Suppliers /></Protected>} />
            <Route path="/bim" element={<Protected><Bim /></Protected>} />
            <Route path="/contratos" element={<Protected><Contracts /></Protected>} />
            <Route path="/cobranza" element={<Protected><Cobranza /></Protected>} />
            <Route path="/contratos/:id" element={<Protected><ContractDetail /></Protected>} />
            <Route path="/estimaciones" element={<Protected><Estimations /></Protected>} />
            <Route path="/estado-cuenta" element={<Protected><EstadoCuenta /></Protected>} />
            <Route path="/documentos" element={<Protected><ProjectDocs config={PLANOS_CONFIG} /></Protected>} />
            <Route path="/normativa" element={<Protected><ProjectDocs config={NORMATIVA_CONFIG} /></Protected>} />
            <Route path="/legales" element={<Protected><ProjectDocs config={LEGALES_CONFIG} /></Protected>} />
            <Route path="/contable" element={<Protected><ProjectDocs config={CONTABLE_CONFIG} /></Protected>} />
            <Route path="/erp" element={<Protected><ErpReports /></Protected>} />
            <Route path="/eliminados" element={<Protected><DeletedRecords /></Protected>} />
            <Route path="/auditorias" element={<Protected><Audits /></Protected>} />
            <Route path="/gastos-fijos" element={<Protected><FixedExpenses /></Protected>} />
            <Route path="/usuarios" element={<Protected><UsersPage /></Protected>} />
            <Route path="/correos" element={<Protected><EmailLog /></Protected>} />
            <Route path="/auditoria" element={<Protected><Auditoria /></Protected>} />
            <Route path="/portal-cliente" element={<Protected><PortalCliente /></Protected>} />
            <Route path="/concursos" element={<Protected><Concursos /></Protected>} />
            <Route path="/reportes" element={<Protected><Reportes /></Protected>} />
            <Route path="/whatsapp" element={<Protected><WhatsAppAlerts /></Protected>} />
            <Route path="/chat" element={<Protected><Chat /></Protected>} />
            <Route path="/tareas" element={<Protected><Tareas /></Protected>} />
            <Route path="/programa" element={<Protected><Programa /></Protected>} />
            <Route path="/ordenes-trabajo" element={<Protected><WorkOrders /></Protected>} />
            <Route path="/directorio" element={<Protected><CompanyDirectory /></Protected>} />
            <Route path="/recorridos" element={<Protected><Recorridos360 /></Protected>} />
            <Route path="/acceso" element={<Protected><Access /></Protected>} />
            <Route path="/partidas" element={<Protected><WorkItems /></Protected>} />
            <Route path="/bitacora" element={<Protected><Bitacora /></Protected>} />
            <Route path="/fotografias" element={<Protected><Photos /></Protected>} />
            <Route path="/empleados" element={<Protected><Employees /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
